import React from 'react';

export default function BasketballVideoOverlay({ videoUrl, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center">
      <div className="relative w-full max-w-4xl mx-4">
        <button onClick={onClose} className="absolute -top-8 right-0 text-white text-sm">Close</button>
        <div className="bg-[#111] rounded-xl p-4 aspect-video flex items-center justify-center text-[#888]">
          {videoUrl ? (
            <video src={videoUrl} controls className="w-full h-full rounded" />
          ) : (
            <span>No video selected</span>
          )}
        </div>
      </div>
    </div>
  );
}
